import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import { Content, DashList, DataListWrap, Td, TitleLeft } from './CourseDetails.styled';
import { useStore } from '@store/appStore';
import Pagination from '../Pagination';
import SortArrow from '../SortArrow';
import fixedNumber from '@utils/fixedNumber';
import RainbowLoader from '@components/Loaders/RainbowLoader';
import EmptyBox from '../EmptyBox';
import { FlexRow } from '../StudentDetails/StudentDetails.styled';
import Tendency from '../StudentDetails/Tendency';
import { ShowabsenceOrAttendance } from '@utils/percentageTools';
import Tooltip from '@components/Tooltips/Tooltip';
import { GenerateExcelFile } from '../excel';
import moment from 'moment';

interface IProps { getCourses: () => void, loading: boolean, handleClick: (username, id, displayname, type) => void }

export const CourseDetails = forwardRef((props: IProps, ref) => {
    useImperativeHandle(ref, () => ({
        exportExcel() {
            Excel()
        },
    }));
  const { client, settings, callNameSetting, filterDate, schoolViewCourses, setSchoolViewCourses, schoolViewFilter, setSchoolViewFilter, page, setPage } = useStore();
  const i18n = useI18n()
  const [sort, setSort] = useState({ type: 3, direction: true })
  const pageSize = 13;
  const [filterText, setFilterText] = useState(null)

  useEffect(() => {
    if (schoolViewFilter.percentage > 0) setFilterText(schoolViewFilter.percentage)
  }, [])

  useEffect(() => {
    getCourses()
  }, [filterDate])

  const getCourses = async () => {
    await props.getCourses()
  }

  const getFilteredCourses = () => {
    let coursesTemp = JSON.parse(JSON.stringify(schoolViewCourses))
    coursesTemp = coursesTemp?.filter(s => { 
        let p = (settings.SHOWPRESENCE?(100 - schoolViewFilter.percentage2):schoolViewFilter.percentage2)
        p = p == 100?0:p;
        return s.percentage >= p}).filter(s => s.displayname?.toLowerCase().includes(schoolViewFilter.search2?.toLowerCase()))
    return coursesTemp
  }

  function handleSort(type) {
    let direction = false;
    if (type === sort.type) direction = !sort.direction
    setSort({ type: type, direction: direction })
  }

  function getSortedCourses() {
    let coursesTemp = getFilteredCourses()
    coursesTemp = coursesTemp?.sort((a, b) => {
      let dir = sort.direction ? -1 : 1
      switch (sort.type) {
        case 0:
          if (a.displayname > b.displayname) return 1 * dir
          else if (a.displayname < b.displayname) return -1 * dir
          else return 0
          break;
        case 1:
          if (a.course_name > b.course_name) return 1 * dir
          else if (a.course_name < b.course_name) return -1 * dir
          else return 0
          break;
        case 2:
          if (a.date > b.date) return 1 * dir
          else if (a.date < b.date) return -1 * dir
          else return 0
          break;
        case 3:
          if (a.percentage > b.percentage) return 1 * dir
          else if (a.percentage < b.percentage) return -1 * dir
          else return 0
          break;
        case 4:
          if (a.current_studentcount > b.current_studentcount) return 1 * dir
          else if (a.current_studentcount < b.current_studentcount) return -1 * dir
          else return 0
          break;
        case 5:
          if (a.absence_type > b.absence_type) return 1 * dir
          else if (a.absence_type < b.absence_type) return -1 * dir
          else return 0
          break;
        case 6:
          let anumber = a.incomplete / (a.complete + a.incomplete) * 100 
          let bnumber = b.incomplete / (b.complete + b.incomplete) * 100 

          if (anumber > bnumber) return 1 * dir
          else if (anumber < bnumber) return -1 * dir
          else return 0
          break;
      }
    })
    return coursesTemp
  }



  const getTextCount = () => {
    let count = getFilteredCourses()?.length
    let totalCount = schoolViewCourses?.length
    if (totalCount === count && count > 0) {
      return `${i18n.t('showing')} ${i18n.t('all').toLowerCase()} ${totalCount}`
    }
    else {
      if (count > 0) {
        return `${i18n.t('showing')} ${count} ${i18n.t('of')} ${totalCount}`
      }
      else
        return ""
    }    
  }

  const Excel = () => {
      let data = getSortedCourses().map(r => {
        let object = {}
  
        object[i18n.t("course-displayname")] = r.displayname;
        object[i18n.t(settings.SHOWPRESENCE?"header-total-attendance":"header-total-absence")] = ShowabsenceOrAttendance(settings.SHOWPRESENCE ,fixedNumber(r.percentage));
        object[i18n.t("header-amount-" + callNameSetting)] = r.current_studentcount;
        object[i18n.t("header-missing-reg")] = r.incomplete + " / " + (r.complete + r.incomplete);        
        return object;
      });
  
      let headers = [
        i18n.t("course-displayname"),
        i18n.t(settings.SHOWPRESENCE?"header-total-attendance":"header-total-absence"),
        i18n.t("header-amount-" + callNameSetting),      
        i18n.t("header-missing-reg")  
      ];
  
      GenerateExcelFile(i18n.t("class") + "_" + moment().format('DD-MM-YYYY-HHmm'), headers, data, i18n.t("class") + "_" + moment().format('DD-MM-YYYY-HHmm'));
    }

  return (<>
    <Content>
      <TitleLeft>
        <span>{i18n.t("course")}</span>
        <span>{getTextCount()}</span>
      </TitleLeft>

      {props.loading ? <RainbowLoader /> : getSortedCourses()?.length > 0 ? <><DataListWrap>

        <DashList>
          <tbody>
            <tr>
              <Td className={"width40"} onClick={() => handleSort(0)}>{i18n.t("course-displayname")} <SortArrow sortActive={sort.type === 0} asc={sort.type === 0 && sort.direction === false} /></Td>
              <Td className={"right width20"} onClick={() => handleSort(3)}>{i18n.t(settings.SHOWPRESENCE?"header-total-attendance":"header-total-absence")} <SortArrow sortActive={sort.type === 3} asc={sort.type === 3 && sort.direction === false} /></Td>
              <Td className={"right width20"} onClick={() => handleSort(4)}>{i18n.t("header-amount-" + callNameSetting)} <SortArrow sortActive={sort.type === 4} asc={sort.type === 4 && sort.direction === false} /></Td>
              <Td className={"right width20"} onClick={() => handleSort(6)}>{i18n.t("header-missing-reg")} <SortArrow sortActive={sort.type === 6} asc={sort.type === 6 && sort.direction === false} /></Td>
            </tr>
            {schoolViewCourses ? getSortedCourses().slice((page * pageSize - pageSize), pageSize * page).map((r, index) => <tr key={"course_" + index}>
              <td className={"width40 clickable"} onClick={() => props.handleClick(r.course_id, r.course_id, r.displayname, 'COURSE')}><Tooltip placement='top-start' content={i18n.t("show-details-course")}>{r.displayname}</Tooltip></td>
              <td className={"right width20"}><span><FlexRow className={"p-right"}>{ShowabsenceOrAttendance(settings.SHOWPRESENCE ,fixedNumber(r.percentage))}%<Tendency tendencyUp={false} courseId={r.course_id} /></FlexRow></span></td>
              <td className={"right width20"}><span className={"p-right"}>{r.current_studentcount}</span></td>
              <td className={"right width20"}><span className={"p-right"}><b>{r.incomplete}</b> / {r.complete + r.incomplete}</span></td>
            </tr>) : null}
          </tbody>
        </DashList>
      </DataListWrap>

        <Pagination pageSize={pageSize} count={getSortedCourses()?.length}  currentPage={page} maxPage={Math.ceil(getSortedCourses()?.length / pageSize)} setPage={setPage} /></> : <EmptyBox Graphic='documents' marvin={true} text={i18n.t("no-filter-data")} />}

    </Content>
  </>);
});

export default CourseDetails;
